<template>
  <div style="overflow-x: hidden;" class="app d-flex flex-column" id="app" v-if="init" :class="classes">
    <transition name="fade" mode="out-in" appear>
      <navbar v-if="$root.user"></navbar>
    </transition>

    <transition name="fade" mode="out-in" appear>
      <router-view class="page-content flex-grow-1"></router-view>
    </transition>

    <app-modals ref="modals"></app-modals>
  </div>
</template>

<script>
  import { pick, get } from 'lodash'
  import auth from '../auth'
  import router from '../router'
  import Raven from '../raven'
  import AppAlert from '../components/app-alert'
  import ReleaseModal from '../components/release-modal'

  export default {
    metaInfo: {
      title: 'Vendoscope',
      titleTemplate: '%s – Vendoscope',
    },
    data () {
      return {
        isDev: (process.env.NODE_ENV === 'development'),
        user: null,
        init: false,
        release: null,
        store: {},
        serviceRoles: [
          'tech_superior',
          'service_superior',
          'tech_chief',
          'service_chief',
          'admin',
          'test_admin',
          'director',
          'branch_admin',
          'superior',
        ],
      }
    },
    router,
    methods: {
      showModal (component, props) {
        return this.$refs.modals.show(component, props)
      },
      closeAllModals (component, props) {
        // return this.$refs.modals.closeAll()
      },
      showAlert (message) {
        return this.showModal(AppAlert, {header: message})
      },
      checkPermission (permission) {
        return this.user ? this.user.permissions.includes(permission) || this.user.permissions.includes(permission + '_edit') : false
      },
      isAdmin () {
        return this.checkPermission('admin_access') || this.checkPermission('web_admin_access')
      },
      canCreateService () {
        return this.checkPermission('web_service_edit')
      },
    },
    mounted () {
      auth.check()
        .then((user) => {
          this.user = user
          if (user.region.current_subscription === 'terminated' && user.region.creator_id === user.id) {
            window.alert('Пользование сервисом ограничено из-за отсутствия средств на счёте')
          }
        })
        .catch(() => {
          this.user = null
        })
        .finally(() => {
          this.init = true
        })
    },
    watch: {
      user () {
        if (Raven) {
          Raven.setUserContext(this.user
            ? pick(this.user, ['id', 'email'])
            : null,
          )
        }
      },
      release (oldRelease, newRelease) {
        if (oldRelease && newRelease) {
          this.showModal(ReleaseModal)
        }
      },
    },
    computed: {
      classes () {
        let path = this.$route.path.replace(/\//g, '-')
        if (path === '-') path = '-index'
        return `page${path}`
      },
    },
  }
</script>

<style lang="scss">
  @import "app";
  .fade-enter-active, .fade-leave-active {
    transition: opacity .1s;
  }
  .fade-enter, .fade-leave-to {
    opacity: 0;
  }
</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/app.vue